// @ts-nocheck
import { Column } from 'react-table'
import { AddressCell, PhoneNumberCell,  DealerIdCell, DealerNameCell, WarehouseNameCell, DivisionCell, ErpIdCell, ZoneCell, DistrictCell, StateCell, CityCell, EmailCell, TaxNumberCell, GstInNumberCell, LicenseNumberCell } from './InfoCell'
//import {UserLastLoginCell} from './UserLastLoginCell'
//import {UserTwoStepsCell} from './UserTwoStepsCell'
import { MyActionsCell } from './MyActionsCell'
//import {MySelectionCell} from './MySelectionCell'
import { MyCustomHeader } from './MyCustomHeader'
//import {MySelectionHeader} from './MySelectionHeader'
import { Dealer } from '../../core/_models'

const MyColumns: ReadonlyArray<Column<Dealer>> = [

  {
    Header: (props) => (
      <MyCustomHeader tableProps={props} title='Actions' className='text-start min-w-100px px-1' />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <MyActionsCell data={props.data[props.row.index]} id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='Division' className='min-w-125px' />,
    id: 'division_name',
    Cell: ({ ...props }) => <DivisionCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='Warehouse' className='min-w-200px' />,
    id: 'warehouse_name',
    Cell: ({ ...props }) => <WarehouseNameCell data={props.data[props.row.index]} />,
  },

  // {
  //   Header: (props) => <MyCustomHeader tableProps={props} title='Dealer Id' className='min-w-100px' />,
  //   id: 'd.dealer_id',
  //   Cell: ({ ...props }) => <DealerIdCell data={props.data[props.row.index]} />,
  // },
  // {
  //   Header: (props) => <MyCustomHeader tableProps={props} title='Erp Id' className='min-w-100px' />,
  //   id: 'd.erp_id',
  //   Cell: ({ ...props }) => <ErpIdCell data={props.data[props.row.index]} />,
  // }, 
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='Dealer' className='min-w-300px' />,
    id: 'd.dealer_name',
    Cell: ({ ...props }) => <DealerNameCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='Zone' className='min-w-150px' />,
    id: 'zone_name',
    Cell: ({ ...props }) => <ZoneCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='State' className='min-w-150px' />,
    id: 'state_name',
    Cell: ({ ...props }) => <StateCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='City' className='min-w-150px' />,
    id: 'city_name',
    Cell: ({ ...props }) => <CityCell data={props.data[props.row.index]} />,
  },
  
 
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='District' className='min-w-150px' />,
    id: 'district_name',
    Cell: ({ ...props }) => <DistrictCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='Address' className='min-w-300px' />,
    id: 'd.address',
    Cell: ({ ...props }) => <AddressCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='Phone No.' className='min-w-150px' />,
    id: 'd.phone_number',
    Cell: ({ ...props }) => <PhoneNumberCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='Email' className='min-w-20px' />,
    id: 'd.email',
    Cell: ({ ...props }) => <EmailCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='Tax Number' className='min-w-150px' />,
    id: 'd.tax_number',
    Cell: ({ ...props }) => <TaxNumberCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='GST In Number' className='min-w-150px' />,
    id: 'd.gst_in_number',
    Cell: ({ ...props }) => <GstInNumberCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <MyCustomHeader tableProps={props} title='License Number' className='min-w-350px' />,
    id: 'd.license_number',
    Cell: ({ ...props }) => <LicenseNumberCell data={props.data[props.row.index]} />,
  },







]

export { MyColumns }
